module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.08cb8f79.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Bold.woff
// module id = 532
// module chunks = 0